import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { DescriptionIcon } from "./DescriptionIcon";
import { Text } from "./Text";

/**
 * Description:
 *  - The component that displays the slide description in scrollables.
 */
export function Description(props) {
  const [viewed, setViewed] = useState(false);

  const description = useRef(null);

  const isPercentageInRange = (condition) =>
    props.percentage > props.minRange &&
    props.percentage < props.maxRange &&
    condition;

  useEffect(() => {
    if (isPercentageInRange(true)) {
      if (!viewed) {
        description.current.focus();
        setViewed(true);
      }
    } else {
      if (viewed) {
        setViewed(false);
      }
    }
  }, [props.percentage]);

  const wrapperClass = () =>
    [
      "description",
      isPercentageInRange(props.percentage > 1) ? "animate" : "",
    ].join(" ");

  return (
    <div className="text-block">
      <div className="text-elements">
        <div
          aria-label={props.ariaLabel}
          className={wrapperClass()}
          id={props.id}
        >
          <DescriptionIcon />
          <p ref={description} className="descriptionText">
            {props.children}
          </p>
        </div>
      </div>
    </div>
  );
}

Description.propTypes = {
  /**
   * Percentage value associated with the scrolltip
   */
  percentage: PropTypes.number.isRequired,
  /**
   * The min-range value from which the description should be displayed
   */
  minRange: PropTypes.number.isRequired,
  /**
   * The max-range value to which teh description should be displayed
   */
  maxRange: PropTypes.number.isRequired,
  /**
   * aria label to be set for the desciption component
   */
  ariaLabel: PropTypes.string,
  /**
   * Id prop to be set for the Description
   */
  id: PropTypes.number,
  /**
   * The contents to be displayed as description
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
};

Description.defaultProps = {
  percentage: 0,
  minRange: 0,
  maxRange: 1,
  ariaLabel: "",
  id: "default",
};

export { Text };
